import request from "./request";

export function getpanel(){
    return request({
        url: "/depotHead/getBuyAndSaleStatistics",
        method: "get",
    });
}

export function Login(data){
    return request({
        url: "/user/login",
        method: "post",
        data
    });
}

export function getcode() {
    return request({
        url: "/user/randomImage",
        method: "get",
    });
}

export function buyOrSalePrice() {
    return request({
    url: "/depotItem/buyOrSalePrice",
    method: "get",
    });
}

export function getInOutStockCountMoney(params) {
    return request({
    url: "/depotItem/getInOutStockCountMoney",
    method: "get",
    params
    })
}

// /statistics/depotSales?beginTime=2025-8-1&endTime=2025-8-26
export function depotSales(params){
    return request({
        url: "/statistics/depotSales",
        method: "get",
        params
    })
}

///depotItem/salesSum
export function salesSum(params) {
    return request({
      url: "/statistics/materialSales",
      method: "get",
      params,
    });
}

export function depotHeadlist(params) {
  return request({
    url: "/depotHead/list",
    method: "get",
    params,
  });
}
// 调拨统计
export function allocation(params) {
  return request({
    url: "/statistics/allocation",
    method: "get",
    params,
  });
}

// 机柜的销售详细数据
export function depotSalesInfo(params) {
  return request({
    url: "/statistics/depotSalesInfo",
    method: "get",
    params,
  });
}